import { render, staticRenderFns } from "./JsryzcxxbgEdit.vue?vue&type=template&id=4530d825"
import script from "./JsryzcxxbgEdit.vue?vue&type=script&lang=js"
export * from "./JsryzcxxbgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports